/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ModuleContainer, PublicationSettingSearchableContentType, UiTitleTreatmentType } from 'data/generated/graphql';

export const getDefaultNewsletterModuleContainer: () => ModuleContainer = () => ({
  collection: [],
  subtype: null,
  type: 'Module',
  attributes: {
    pageModule: {
      uiModuleFields: {
        basicModule: {
          treatmentType: UiTitleTreatmentType.StandardNewsletter,
          contentTypes: [PublicationSettingSearchableContentType.Article],
          allowedTreatmentTypes: null
        }
      },
      // @ts-ignore
      uiModuleType: 'UiBasicModuleType'
    }
  }
});

export const DEBOUNCE_TIMEOUT = 500;
